import React from 'react';
import carbonis from "../carbonis.png";
import { UilEnvelopeShield } from '@iconscout/react-unicons';

export default function SignUp() {
    return (
        <div className="columns section">
            <div className="column"></div>
            <div className="field column is-center">
                <img src={carbonis} style={{ width: '200px' }}></img>
                <p className="control has-icons-left has-icons-right">
                    <p>
                        <h2 style={{ margin: '20px auto' }}>Email succesfully verified!</h2>
                    </p>
                    <p>
                        <h2 style={{ margin: '20px auto' }}>Redirecting you to login....</h2>
                    </p>
                </p>
            </div>
            <div className="column"></div>
        </div>
    )
}
